import { render, staticRenderFns } from "./remove_issue.vue?vue&type=template&id=f42d291e&"
import script from "./remove_issue.vue?vue&type=script&lang=js&"
export * from "./remove_issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports